import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-heart-pulse-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-800">
                女性健康指南
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              科学认识女性身体，守护生殖健康。提供专业、易懂的女性生殖系统科普知识。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">知识分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/anatomy" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">解剖结构</Link>
              <Link to="/category/physiology" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">生理功能</Link>
              <Link to="/category/diseases" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">常见疾病</Link>
              <Link to="/category/wellness" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">健康保养</Link>
              <Link to="/category/examination" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">检查指南</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">热门文章</h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/ovary-structure-function" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">卵巢结构功能详解</Link>
              <Link to="/article/uterus-anatomy-menstruation" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">子宫结构与月经周期</Link>
              <Link to="/article/pcos-diagnosis-treatment" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">PCOS诊治指南</Link>
              <Link to="/article/cervical-cancer-screening" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">宫颈癌筛查攻略</Link>
              <Link to="/article/menopause-health-management" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">围绝经期健康管理</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">品牌介绍</Link>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">联系方式</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 女性健康指南. 本站内容仅供参考，不构成医疗建议。如有健康问题请及时就医。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
              <i className="ri-mail-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}